import script from "./EmployeeMobileBottomNav.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeMobileBottomNav.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeMobileBottomNav.vue?vue&type=style&index=0&id=3a2133f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a2133f4"]])

export default __exports__